import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import ArrowDown from 'public/images/icons/arrow_down.svg';
import styled from 'styled-components';

export const List = styled.div(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.surface04}`,
  marginTop: theme.spacing[24],
  textAlign: 'left',
}));

export const Item = styled.div(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.surface04}`,
}));

/** Resets the heading's own margins so the button, not the heading, sets the row height. */
export const QuestionHeading = styled.h3({
  margin: 0,
});

export const QuestionButton = styled.button(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[16],
  width: '100%',
  padding: `${theme.spacing[16]} 0`,
  border: 'none',
  background: 'none',
  color: theme.colors.highEmphasisBlack,
  textAlign: 'left',
  cursor: 'pointer',
}));

export const QuestionText = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})(({ theme }) => ({
  margin: 0,
  fontWeight: theme.fontWeight.medium,
}));

// The icon file ships `fill="none"`, so it is invisible until the path is given a colour.
export const Chevron = styled(ArrowDown)<{ $expanded: boolean }>(({ theme, $expanded }) => ({
  flexShrink: 0,
  path: { fill: theme.colors.highEmphasisBlack },
  transform: $expanded ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.2s ease',
}));

/** The RichText paragraphs bring their own spacing; this only closes the gap to the divider. */
export const Answer = styled.div(({ theme }) => ({
  paddingBottom: theme.spacing[16],
}));
